export default "__VITE_ASSET__DH7zGZRF__";